import { Text } from "@gravity-ui/uikit";

import { formatReleaseDate } from "./ReleaseDateCell.utils";

interface ReleaseDateCellProps {
  releaseDate: string | null;
}

const UNKNOWN_RELEASE_DATE = "—";

export const ReleaseDateCell = ({ releaseDate }: ReleaseDateCellProps) => {
  const label = formatReleaseDate(releaseDate);

  if (!label) {
    return (
      <Text variant="body-1" color="secondary">
        {UNKNOWN_RELEASE_DATE}
      </Text>
    );
  }

  return <Text variant="body-1">{label}</Text>;
};
